
export const styles = {
  container: {
    backgroundColor: 'bg-[#001845]',
    background: 'bg-gradient-to-b from-[#001845] to-[#000C22]',
    border: 'border border-cyan-400/30',
    shadow: 'shadow-2xl shadow-cyan-400/20',
    animation: 'hologram-grid 20s linear infinite',
    position: 'relative',
    overflow: 'hidden'
  },
  header: {
    background: 'bg-[#001845]',
    backdropFilter: 'backdrop-blur-md',
    textColor: 'text-cyan-400',
    border: 'border-b border-cyan-400/30',
    animation: 'message-appear 0.5s ease-out'
  },
  avatar: {
    background: 'bg-[#001845]/80',
    text: 'text-cyan-400',
    border: 'border border-cyan-400/50',
    animation: 'avatar-rotate 10s linear infinite',
    glow: 'shadow-lg shadow-cyan-400/50'
  },
  messages: {
    bot: {
      background: 'bg-[#001845]/60',
      backdropFilter: 'backdrop-blur-md',
      text: 'text-white',
      shadow: 'shadow-lg shadow-cyan-400/20',
      border: 'border border-cyan-400/30',
      animation: 'message-appear 0.5s ease-out'
    },
    user: {
      background: 'bg-cyan-500/20',
      backdropFilter: 'backdrop-blur-md',
      text: 'text-white',
      shadow: 'shadow-lg shadow-cyan-400/20',
      border: 'border border-cyan-400/30',
      animation: 'message-appear 0.5s ease-out'
    }
  },
  typingIndicator: {
    background: 'bg-[#001845]/60',
    backdropFilter: 'backdrop-blur-sm',
    dot: 'bg-cyan-400',
    border: 'border border-cyan-400/30',
    animation: 'hologram-typing 1.5s infinite'
  },
  input: {
    background: 'bg-[#001845]/60',
    backdropFilter: 'backdrop-blur-md',
    text: 'text-white',
    placeholder: 'text-cyan-400/50',
    border: 'border border-cyan-400/30 focus:border-cyan-400',
    transition: 'all 0.3s ease',
    button: {
      background: 'bg-cyan-500/80 hover:bg-cyan-400/80',
      backdropFilter: 'backdrop-blur-sm',
      text: 'text-white',
      animation: 'hologram-scan 3s linear infinite',
      hover: {
        transform: 'translateY(-2px)',
        shadow: 'shadow-lg shadow-cyan-400/50'
      }
    }
  },
  animations: {
    '@keyframes hologram-grid': {
      '0%': {
        backgroundPosition: '0 0',
        opacity: 0.5
      },
      '50%': {
        backgroundPosition: '10px 10px',
        opacity: 0.3
      },
      '100%': {
        backgroundPosition: '20px 20px',
        opacity: 0.5
      }
    },
    '@keyframes message-appear': {
      '0%': {
        transform: 'translateY(20px)',
        opacity: 0
      },
      '100%': {
        transform: 'translateY(0)',
        opacity: 1
      }
    },
    '@keyframes hologram-scan': {
      '0%': {
        transform: 'translateX(-100%) skewX(-20deg)'
      },
      '100%': {
        transform: 'translateX(100%) skewX(-20deg)'
      }
    },
    '@keyframes avatar-rotate': {
      '0%': {
        transform: 'perspective(1000px) rotateY(0deg)'
      },
      '100%': {
        transform: 'perspective(1000px) rotateY(360deg)'
      }
    },
    '@keyframes hologram-typing': {
      '0%, 100%': {
        transform: 'translateY(0) scale(1)',
        opacity: 0.5,
        filter: 'blur(0px)'
      },
      '50%': {
        transform: 'translateY(-4px) scale(1.2)',
        opacity: 1,
        filter: 'blur(1px)'
      }
    }
  },
  effects: {
    grid: {
      position: 'absolute',
      inset: 0,
      backgroundImage: 'linear-gradient(to right, rgba(0,255,255,0.1) 1px, transparent 1px), linear-gradient(to bottom, rgba(0,255,255,0.1) 1px, transparent 1px)',
      backgroundSize: '20px 20px',
      animation: 'hologram-grid 20s linear infinite'
    },
    noise: {
      position: 'absolute',
      inset: 0,
      backgroundImage: "url('data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.65' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%' height='100%' filter='url(%23noise)' opacity='0.05'/%3E%3C/svg%3E')",
      opacity: 0.1,
      animation: 'noise 0.5s steps(2) infinite'
    },
    scanline: {
      position: 'absolute',
      inset: 0,
      background: 'linear-gradient(to bottom, transparent, rgba(0,255,255,0.2), transparent)',
      animation: 'hologram-scan 3s linear infinite'
    }
  }
}; 